import React, { Component }  from 'react';
import AdminTable            from '../../components/AdminTable.jsx';
import PageHeaderBar         from '../../components/PageHeaderBar.jsx';
import Modal                 from '../../components/Modal.jsx';
import CategoryForm          from './CategoryForm.jsx';
import { categoryRecord }    from './categoryRecord.js';
import { statusTypesLookup } from '../../data/refData.js';
import { fetchEndpoint,
         imageArray }        from '../../functions.js';

class Categories extends Component {

  constructor() {
    super();
    this.tableRef = React.createRef();
    this.formRef  = React.createRef();
    this.state = {
      mode          : 'list',   // list | create | edit
      currentItem   : {},       // The category being created or manipulated
      deleteModal   : false,    // Toggles visibility of delete modal
    };
  }

  onCloseModal      = ()     => this.setState({ deleteModal: false });
  gotoListMode      = ()     => this.setState({ mode: 'list' });
  createItem        = ()     => this.setState({ currentItem : categoryRecord(null, 'create'), mode : 'create' });
  editItem          = (item) => this.setState({ currentItem : categoryRecord(item, 'edit'  ), mode : 'edit'   });
  copyItem          = (item) => this.setState({ currentItem : categoryRecord(item, 'create'), mode : 'create' });
  promptForDeletion = (item) => this.setState({ currentItem : item, deleteModal: true });

  onSaveItem = async () => {

    const { notifySuccess, notifyError } = this.props;
    const { mode } = this.state;
    // get the form item data via its reference
    const { item } = this.formRef.current.state;
    item.cat_images = imageArray(item.cat_images);

    let saveURL = '/api/categories';
    if (mode === 'edit') saveURL += '/'+ item._id;
    await fetchEndpoint({
      url       : saveURL,
      body      : item,
      onSuccess : () => {
        notifySuccess(`${item.cat_title} saved`);
        this.setState({ mode : 'list' }, () => {
          this.tableRef.fireFetchData();
        });
      },
      onError   : (error) => {
        console.log('error during save', error);
        notifyError('sorry there was an error and you cannot continue');
      },
    });
  }

  onDeleteCurrentItem = async () => {
    const { currentItem } = this.state;
    const { notifySuccess, notifyError } = this.props;
    await fetchEndpoint({
      url       : '/api/categories/' + currentItem._id,
      method    : 'DELETE',
      onSuccess : () => {
        notifySuccess(`Category deleted: ${currentItem.cat_title}`);
        this.setState({ mode : 'list' }, () => {
          this.onCloseModal();
          this.tableRef.fireFetchData();
        });
      },
      onError   : (error) => {
        console.log('error during delete', error);
        notifyError('sorry there was an error and you cannot continue');
      },
    });
  }

  render() {

    const { notifyError } = this.props;
    const { mode, currentItem, deleteModal } = this.state;
    const columns = [
      { 
        Header    : 'Title',
        id        : 'cat_title',
        accessor  : 'cat_title',
        resizable : true,
      },
      { 
        Header    : '# Shares',
        id        : '_counts.shares',
        accessor  : '_counts.shares',
        maxWidth  : 80,
        resizable : false,
        Cell      : field => (<div style={{ textAlign: 'center' }}>{field.value}</div>),
      },
      { 
        Header    : '# Interests',
        id        : '_counts.interests',
        accessor  : '_counts.interests',
        maxWidth  : 80,
        resizable : false,
        Cell      : field => (<div style={{ textAlign: 'center' }}>{field.value}</div>),
      },
      { 
        Header    : '# Topics',
        id        : '_counts.topics',
        accessor  : '_counts.topics',
        maxWidth  : 80,
        resizable : false,
        Cell      : field => (<div style={{ textAlign: 'center' }}>{field.value}</div>),
      },
      { 
        Header    : 'Status',
        id        : 'cat_status',
        accessor  : 'cat_status.sta',
        sortable  : true,
        maxWidth  : 110,
        resizable : false,
        Cell      : field => (<div style={{ textAlign: 'center' }}>{statusTypesLookup(field.value)}</div>),
      },
      { 
        Header    : 'Actions',
        sortable  : false,
        maxWidth  : 150,
        resizable : false,
        Cell      : field => (
          <div style={{ textAlign: 'center' }}>
            <span className="tbl-lnk" onClick={()=>this.editItem(field.original)}>Edit</span>
            &nbsp;|&nbsp;
            <span className="tbl-lnk" onClick={()=>this.copyItem(field.original)}>Copy</span>
            &nbsp;|&nbsp;
            <span className="tbl-lnk" onClick={()=>this.promptForDeletion(field.original)}>Delete</span>
          </div>
        ),
      },
    ];

    return (
      <div>
        <PageHeaderBar
          mode={mode}
          typeSingle="Category"
          typePlural="Categories"
          onCreate={this.createItem}
          onCancel={this.gotoListMode}
          onSave={this.onSaveItem}
        />
        <div style={{ display: mode === 'list' ? 'block' : 'none' }}>
          <AdminTable
            setTableRef={(tableRef) => this.tableRef = tableRef}
            fetchURL={'/api/categories'}
            notifyError={notifyError}
            columns={columns}
            filters={[
              { title: 'Title',  name: 'cat_title',      type: 'text'   },
              { title: 'Status', name: 'cat_status.sta', type: 'status' },
            ]}
            defaultSorted={{ id: 'name', desc: false }}
          />

        </div>

        {['create', 'edit', 'copy'].includes(mode) && (
          <CategoryForm ref={this.formRef} item={currentItem} />
        )}

        <Modal
          title={`Delete Category: ${currentItem ? currentItem.cat_title : ''}`}
          open={deleteModal}
          action="Delete"
          onAction={this.onDeleteCurrentItem}
          onClose={this.onCloseModal}
        />
        
      </div>
    );
  }
}

export default Categories;
